import { useUser } from "@/auth/useUser";
import { useMultiProviderAvailableResourcesQuery } from "@/graphql/queries/multiProviderAvailableResources.graphql.types";
import useMedspaTimezone from "@/hooks/common/useMedspaTimezone";

type AppointmentService = {
  serviceMenuItem: { id: string };
  startTime: Date;
  endTime: Date;
};

export const useAppointmentAvailableResources = ({
  appointmentServices,
}: {
  appointmentServices: AppointmentService[];
}) => {
  const { medspaZonedTimeToUtc } = useMedspaTimezone();
  const { medspa } = useUser();

  const { data } = useMultiProviderAvailableResourcesQuery({
    variables: {
      medspaId: medspa,
      services: appointmentServices.map((service) => ({
        serviceMenuItemId: service.serviceMenuItem.id,
        startTime: medspaZonedTimeToUtc(service.startTime).toISOString(),
        endTime: medspaZonedTimeToUtc(service.endTime).toISOString(),
      })),
    },
    fetchPolicy: "cache-and-network",
    skip: !medspa || !appointmentServices.length,
  });

  return data?.availableResourcesMultiProvider;
};
